// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sableye_mega: PokeData = {
  "id": 10066,
  "name": "sableye-mega",
  "height": 5,
  "weight": 1610,
  "base_experience": 168,
  "types": [
    PokeType.DARK,
    PokeType.GHOST
  ],
  "api_moves": [
    "scratch",
    "leer",
    "night-shade",
    "confuse-ray",
    "fury-swipes",
    "feint-attack",
    "foresight",
    "detect",
    "mean-look",
    "shadow-ball",
    "fake-out",
    "knock-off",
    "astonish",
    "punishment",
    "power-gem",
    "shadow-claw",
    "shadow-sneak",
    "zen-headbutt",
    "foul-play",
    "quash"
  ],
  "moves": [
    "scratch",
    "leer",
    "night-shade",
    "confuse-ray",
    "shadow-ball",
    "shadow-sneak",
    "zen-headbutt",
    "quash",
    "spectral-snatch",
    "snarl",
    "flatter",
    "spectral-chain",
    "shadow-dagger"
  ],
  "evolution_chain": {
    "id": 149,
    "item": null,
    "species": [
      {
        "name": "sableye",
        "order": 328,
        "types": [
          PokeType.DARK,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 170,
    "speed": 40,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
